import type { Route, Routes } from '@angular/router';
import { authGuard, authMatchGuard } from '@core/guards/auth.guard';

/** Dashboard layout route with auth guards. */
export function protectedDashboardRoute(path: string, children: Routes): Route {
  return {
    path,
    canMatch: [authMatchGuard],
    canActivate: [authGuard],
    loadComponent: () =>
      import('@layouts/dashboard-layout/dashboard-layout.component').then(
        (m) => m.DashboardLayoutComponent,
      ),
    children,
  };
}
